<template>
  <div class="latest-season-container" v-if="list.length">
    <!-- cases list -->
    <CasesList :cases="casesTabs" v-model="casesValue" @change="handlerCasesChange" />
    <!-- weapon view -->
    <WeaponView :weaponInfo="currentWeapon" />
    <!-- weapon list -->
    <WeaponList v-model="weaponValue" :options="weaponOptions" :category="categoryValue" keyCode="id"
      @weapon-click="handleWeaponClick" v-if="!isMobile">
      <template #default="{ option, category, isActive }">
        <WeaponItem :weapon-info="option" :category="category" :is-active="isActive" :isSmall="isMobile" />
      </template>
    </WeaponList>
    <WeaponMobileList v-else v-model="weaponValue" :options="weaponOptions" keyCode="id"
      @weapon-click="handleWeaponClick">
      <template #default="{ option, category, isActive }">
        <WeaponItem :weapon-info="option" :category="category" :is-active="isActive" :isSmall="isMobile" />
      </template>
    </WeaponMobileList>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import CasesList from "./components/casesList";
import WeaponList from "../weaponList";
import WeaponItem from "../weaponList/components/item";
import WeaponView from "./components/weaponView";
import WeaponMobileList from "../weaponList/components/mobileList";

export default {
  mixins: [responsiveMixin],
  components: { CasesList, WeaponList, WeaponItem, WeaponView, WeaponMobileList },
  data() {
    return {
      casesTabs: [],
      casesValue: "",
      weaponValue: "",
      currentWeapon: {},
      weaponOptions: [],
      categoryValue: ""
    };
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    handlerCasesTabs(list) {
      this.casesTabs = list.map(item => {
        return {
          label: item.name,
          image: item.image,
          value: item.id
        }
      });
      if (this.casesTabs.length) {
        this.casesValue = this.casesTabs[0].value;
        this.weaponOptions = list[0].weapons;
        this.currentWeapon = this.weaponOptions.length && this.weaponOptions[0];
        this.weaponValue = this.currentWeapon.id;
      }
    },
    handlerCasesChange(row) {
      const index = this.list.findIndex(item => item.id === row.value);
      this.weaponOptions = this.list[index].weapons;
      this.currentWeapon = this.weaponOptions.length && this.weaponOptions[0];
      this.weaponValue = this.currentWeapon.id;
    },
    handleWeaponClick(row) {
      this.weaponValue = row.id;
      this.currentWeapon = row;
    }
  },
  watch: {
    list: {
      handler(newValue) {
        this.handlerCasesTabs(newValue);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
